import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as MoreVertical } from '../../icons/more-vertical.svg';
import { ReactComponent as StatusUpIcon } from '../../icons/status-up.svg';
import { ReactComponent as StarIcon } from '../../icons/star.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import '../action_dropdown/ActionDropdown.css';

function PromoActionDropdown({ promo, onRenew, onPromote, onDelete }) {
    const [isOpen, setIsOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        if (isOpen && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const menuWidth = 200;
            setMenuPosition({
                top: rect.bottom + 8,
                left: rect.right - menuWidth
            });
        }
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                triggerRef.current &&
                !triggerRef.current.contains(e.target) &&
                menuRef.current &&
                !menuRef.current.contains(e.target)
            ) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        const handleScroll = () => {
            if (isOpen) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            window.addEventListener('scroll', handleScroll, true);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [isOpen]);

    const handleToggle = (e) => {
        e.stopPropagation();
        setIsOpen((prev) => !prev);
    };

    const handleAction = (action) => (e) => {
        e.stopPropagation();
        setIsOpen(false);
        if (action) action(promo);
    };

    const renderMenu = () => {
        if (!isOpen) return null;

        return ReactDOM.createPortal(
            <div
                className="action-dropdown-menu-portal"
                ref={menuRef}
                style={{
                    position: 'fixed',
                    top: menuPosition.top,
                    left: menuPosition.left,
                    zIndex: 999999
                }}
            >
                <button
                    className="action-dropdown-item"
                    onClick={handleAction(onRenew)}
                >
                    <StatusUpIcon className="action-dropdown-icon" />
                    <span>Ponów promowanie</span>
                </button>
                <button
                    className="action-dropdown-item"
                    onClick={handleAction(onPromote)}
                >
                    <StarIcon className="action-dropdown-icon" />
                    <span>Promuj wydarzenie</span>
                </button>
                <div className="action-dropdown-divider" />
                <button
                    className="action-dropdown-item action-dropdown-item-danger"
                    onClick={handleAction(onDelete)}
                >
                    <TrashIcon className="action-dropdown-icon" />
                    <span>Usuń</span>
                </button>
            </div>,
            document.body
        );
    };

    return (
        <div className={`action-dropdown-container ${isOpen ? 'open' : ''}`}>
            <button
                ref={triggerRef}
                className={`action-dropdown-trigger ${isOpen ? 'active' : ''}`}
                onClick={handleToggle}
                type="button"
                aria-label="Akcje"
            >
                <MoreVertical />
            </button>
            {renderMenu()}
        </div>
    );
}

export default PromoActionDropdown;
